import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../serviceRecommendation.module.scss';

type PartQuantityProps = {
  title: string,
  quantity: string
}

export const ServiceRecommendationPartQuantity = ({ title, quantity }: PartQuantityProps) => {
  return (
    <div className={styles['part-quantity']}>
      <CatHeading variant="label-sm" className={styles['part-quantity_title']} data-testid='quantity'>
        {title}
      </CatHeading>
      <CatHeading variant="label-lg">{quantity}</CatHeading>
    </div>
  );
};
